var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-8 flex h-72 items-center justify-center text-[55px] font-semibold tracking-[-0.29px]"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }